import React from "react";
// import { useNavigate } from 'react-router-dom';

const Profile = () => {
    // const navigate = useNavigate();
    return (
        <div>
            <h1>
                Profile Tester
            </h1>

            <p>
                This will eventually be the profile page.
            </p>
        </div>
    );
}

export default Profile;